module.exports = __webpack_public_path__ + "static/img/hot.b024e89e.webp";